import React from "react";
import VehicleSVG from "../assets/vehicleSVG.svg";

export default function VehicleImage(props) {
    return (
        <img src={VehicleSVG} alt="" {...props}/>
    )
}
